// Project Imports
import checkIsValueEmpty from "utils/checkIsValueEmpty"
import { EMAIL_REGEX } from 'constants/Constants'
import SolutionStore from "modules/solution/store/SolutionStore"
import { EMPLOYER_EMPLOYEE_SCHEME_A, HUF, KEYMAN, PARTNERSHIP, MWP_ACT, EMPLOYER_EMPLOYEE_SCHEME_B } from "constants/ CustomerType";
import AuthStore from "modules/login/store/AuthStore";



function validateMobileNo(value, validator) {

  if(value === 0){
        return [false, "This field is mandatory"]
    }

 if(value.length == 0){
        return [false, "This field is mandatory"]
    }

    if (!validator.isInt(value.toString())) {
        return [false, "Please enter only numbers"]
    }

    let firstCharacter = parseInt(value.charAt(0))

    if (firstCharacter < 6) {
        return [false, "First digit should be between 6 - 9 "]
    }

    if (value.length !== 10) {
        return [false, "Please enter 10 digit mobile number"]
    }

    return [true, ""]
}


function validateEmail(value, validator) {

    const isCloseBtnClicked = SolutionStore.isCloseBtnClicked
    if (!isCloseBtnClicked) {
        if (validator.isEmpty(value)) {
            return [false, "This field is mandatory"]
        }
    }

    if (!validator.isEmpty(value) && !EMAIL_REGEX.test(value)) {
        return [false, "Please enter a valid Email"]
    }

    return [true, ""]
}

function validateName(value, validator) {

    if (validator.isEmpty(value)) {
        return [false, "This field is mandatory"]
    }
    return [true, ""]
}


export function validatedSalutation({ field, form, validator }){

    let currentFieldValue = field.value

    if(checkIsValueEmpty(currentFieldValue)){
        return [false, "This field is mandatory"]
    }
    return [true, ""]
}



export function validationForEmailAndMobileNumber({ field, form, validator }) {

    let currentFieldName = field.name
    let currentFieldValue = field.value

    switch (currentFieldName) {
        case "mobile_number":
            //  case "whatsapp_mobile_number":
            // mobile no
            return validateMobileNo(currentFieldValue, validator)
        case "email":
            //email
            return validateEmail(currentFieldValue, validator)
            break;
    }

    return [true, ""]

}

export function validationForName({ field, form, validator }) {

    let currentFieldValue = field.value
    let fieldName = field.name
    let validJourneyTypes = [EMPLOYER_EMPLOYEE_SCHEME_A, HUF, PARTNERSHIP, KEYMAN, MWP_ACT,EMPLOYER_EMPLOYEE_SCHEME_B];
    if (validJourneyTypes.includes(AuthStore.journeyTypeName)) {
        if (fieldName === 'last_name') {
            return [true, ""]
        } else {
            return validateName(currentFieldValue, validator)
        }
    } else {
        return validateName(currentFieldValue, validator)
    }

}

export function validationForCountryCode({field, form, validator}) {

    let currentFieldValue = field.value

    if (currentFieldValue.length > 2 || currentFieldValue.length <= 0) {
        return [false, "enter valid country code"]
    }
    return [true, ""]
}
export function validateAlternateMobile({ field, form, validator }) {
    let alternateMobile = field?.value
    let memberField = field?.path?.split(".")
    let mobileNumber = form?.$(memberField[0])?.$("mobile_number")?.value
    if (alternateMobile?.length > 0) {
        if (alternateMobile?.length === 10 && mobileNumber === alternateMobile) {
            return [false, "Mobile Number and Alternate Number is should not be same"]
        }
        return validateMobileNo(alternateMobile, validator)
    }
    return [true, ""]
}